import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';

setAutoFreeze(false); // 禁止凍結

const localRequirement = JSON.parse(sessionStorage.getItem('custom-itinerary-requirement'));

const initialState = {
  day: localRequirement?.day ?? null,
  departure: localRequirement?.departure ?? '',
  from: localRequirement?.from ?? '',
  to: localRequirement?.to ?? '',
  adult: localRequirement?.adult ?? null,
  child_bed: localRequirement?.child_bed ?? 0,
  child_bed_age: localRequirement?.child_bed_age ?? [],
  child_noBed: localRequirement?.child_noBed ?? 0,
  child_noBed_age: localRequirement?.child_noBed_age ?? [],
  baby: localRequirement?.baby ?? 0,
  babySeat: localRequirement?.babySeat ?? null,
  budget: localRequirement?.budget ?? '',

  airline: localRequirement?.airline ?? [],
  airlineOther: localRequirement?.airlineOther ?? '',
  timePeriod: localRequirement?.timePeriod ?? [],
  seatType: localRequirement?.seatType ?? [],
  hotel: localRequirement?.hotel ?? [],
  hotelOther: localRequirement?.hotelOther ?? '',
  dining: localRequirement?.dining ?? '',
  note: localRequirement?.note ?? '',
  expense: localRequirement?.expense ?? [],
};

export const requirementSlice = createSlice({
  name: 'requirement',
  initialState,
  reducers: {
    requirementUpdate: (state, action) => {
      sessionStorage.setItem('custom-itinerary-requirement', JSON.stringify(action.payload));
      return action.payload;
    },
    requirementReset: () => {
      sessionStorage.removeItem('custom-itinerary-requirement');
      return {
        day: null,
        departure: '',
        from: '',
        to: '',
        adult: null,
        child_bed: 0,
        child_bed_age: [],
        child_noBed: 0,
        child_noBed_age: [],
        baby: 0,
        babySeat: null,
        budget: '',
        airline: [],
        airlineOther: '',
        timePeriod: [],
        seatType: [],
        hotel: [],
        hotelOther: '',
        dining: '',
        note: '',
        expense: [],
      };
    },
  },
});

export const requirementSelect = (state) => state.requirement;
export const { requirementUpdate, requirementReset } = requirementSlice.actions;
export default requirementSlice.reducer;
